module.exports = __webpack_public_path__ + "img/block2-0.dcf9786d.jpg";